import React from "react";
import AboutSection from "../Components/AboutUs/AboutSection";
import BenefitsSection from "../Components/AboutUs/BenefitsSection";
import ServeSection from "../Components/AboutUs/ServeSection";

export default function AboutUsPage() {
  return (
    <div>
      <AboutSection />
      <ServeSection />
      <BenefitsSection />
    </div>
  );
}
